import { QualifiedSignatureProperties } from '@dropbox/sign-internal-client';
import { LocationDescriptor } from 'history';

export function getEidRedirect(
  signatureRequestId: string,
  data: Readonly<Partial<QualifiedSignatureProperties>>,
): LocationDescriptor | null {
  const {
    qesUrl,
    eidProviderClientId,
    eidHasAdditionalSigningMethods,
    eidCountryCode,
  } = data;
  if (qesUrl && eidProviderClientId) {
    const searchParams = new URLSearchParams();

    searchParams.set('qesUrl', qesUrl);
    searchParams.set('clientId', eidProviderClientId);
    searchParams.set(
      'hasAdditionalSigningMethods',
      eidHasAdditionalSigningMethods ? '1' : '0',
    );
    if (eidCountryCode) {
      searchParams.set('countryCode', eidCountryCode);
    }

    const search = searchParams.toString();
    return {
      pathname: `/sign/${signatureRequestId}/eidComplete`,
      search,
    };
  } else {
    return null;
  }
}
